import styled from 'styled-components';

import anchorStyles from './anchorStyles';

const A = styled.a`
  ${anchorStyles};
`;

export default A;
